import {useCallback} from 'react';

import EppoFlags from '@/EppoFlags';
import {useStringAssignmentExperimentDetails} from '@/eppoHooks';
import useIdentity from '@/hooks/useIdentity';

/**
 * FixOurFoundationsNavbarPhase2b — arm gate plus a caller-driven exposure.
 */
const useFofNavbarPhase2b = () => {
  const {isLoggedIn, isMasquerading} = useIdentity();
  const {variation, trackExperimentExposed} = useStringAssignmentExperimentDetails(
    EppoFlags.FixOurFoundationsNavbarPhase2b,
  );

  const isEligible = isLoggedIn && !isMasquerading;

  const trackExposure = useCallback(() => {
    if (!isEligible || variation === 'fallback') return;

    trackExperimentExposed();
  }, [isEligible, variation, trackExperimentExposed]);

  const isFofNavbarPhase2bTreatment = variation === 'treatment';

  return {isFofNavbarPhase2bTreatment, isEligible, variation, trackExposure};
};

export default useFofNavbarPhase2b;
